import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@/components/Button';
import ConfirmationModal from '@/components/ConfirmationModal';
import { deleteUser } from '@/store/profile/thunks';
import { showError, showSuccess } from '@/utils';

function CloseAccount({ title, description }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const canDeleteAccount = useSelector(
		state => state.profile.user?.canDeleteAccount
	);

	function handleSubmit() {
		setOpen(false);

		dispatch(deleteUser())
			.unwrap()
			.then(() => {
				setLoading(false);
				showSuccess(t('account.toast'));
			})
			.catch(error => {
				showError(error);
				setLoading(false);
			});
	}

	function removeUserModal(event) {
		event.preventDefault();
		setOpen(true);
	}

	if (!canDeleteAccount) {
		return null;
	}

	return (
		<>
			<div className="rounded border border-grey-100">
				<div className="flex justify-between gap-2 p-6 pb-12">
					<div className="flex max-w-[17.75rem] flex-col 2xl:max-w-[21.25rem]">
						<h2 className="text-base font-semibold leading-7">{title}</h2>
						<p className="text-xs leading-5 text-grey-500">
							{description}
						</p>
					</div>
				</div>

				<div className="flex items-center justify-end border-t border-grey-100 px-6 py-3">
					<Button
						loading={loading}
						type="button"
						onClick={removeUserModal}
						className="bg-red"
					>
						{t('account.delete')}
					</Button>
				</div>
			</div>
			<ConfirmationModal
				open={open}
				onClose={() => setOpen(false)}
				title={t('account.close.title')}
				text={t('account.close.description')}
				confirmText={t('common.closeAccount')}
				loading={loading}
				onConfirm={handleSubmit}
			/>
		</>
	);
}

export default CloseAccount;
